var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileAvator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "-1.5 -1 22 22",
    "aria-labelledby": titleId,
    unstroked: "true",
    role: "presentation",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "box",
    lang: "en"
  }, "box icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "box",
    lang: "en"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 5,
    r: 4,
    strokeWidth: "2px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00002 15.9973C0.998661 15.6635 1.078 15.3338 1.23204 15.0331C1.71541 14.1234 3.07852 13.6413 4.20962 13.423C5.02536 13.2592 5.85238 13.1498 6.68449 13.0955C8.2251 12.9682 9.77461 12.9682 11.3152 13.0955C12.1473 13.1504 12.9742 13.2598 13.7901 13.423C14.9212 13.6413 16.2843 14.0779 16.7677 15.0331C17.0774 15.6461 17.0774 16.3577 16.7677 16.9707C16.2843 17.9258 14.9212 18.3625 13.7901 18.5717C12.9753 18.7423 12.148 18.8548 11.3152 18.9083C10.0613 19.0083 8.8015 19.0265 7.5449 18.9629C7.25488 18.9629 6.97452 18.9629 6.68449 18.9083C5.85483 18.8555 5.03069 18.7429 4.21929 18.5717C3.07852 18.3625 1.72508 17.9258 1.23204 16.9707C1.07879 16.6665 0.999527 16.334 1.00002 15.9973Z",
    strokeWidth: "2px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAvator);
export default __webpack_public_path__ + "static/media/profile-avator.ad4ba6a4d1025b234450543c8dc3a3bd.svg";
export { ForwardRef as ReactComponent };